export const FIELD_STYLES = {
  fontSize: '0.875rem',
  lineHeight: 1.5,
  paddingY: '10px',
  paddingX: '12px',
  minHeight: 40,
};